import React from 'react';
import { Box, Typography } from '@mui/material';

const RecentActivityCard = ({ items, formatDate }) => {
    if (items.length === 0) return null;

    return (
        <Box className="notification-page-recent-card">
            <Typography className="notification-page-panel-title">Recent activity</Typography>
            {items.map((item, index) => (
                <Box key={item?.id || index} className="notification-page-recent-item">
                    <Typography className="notification-page-recent-name">{item?.subject || '--'}</Typography>
                    <Typography className="notification-page-recent-date">{formatDate(item?.created_at)}</Typography>
                </Box>
            ))}
        </Box>
    );
};

export default RecentActivityCard;